import { render, staticRenderFns } from "./gaoxueya.vue?vue&type=template&id=1007b6ee&"
import script from "./gaoxueya.vue?vue&type=script&lang=ts&"
export * from "./gaoxueya.vue?vue&type=script&lang=ts&"
import style0 from "./gaoxueya.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports